import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { ControlDTO } from '../../../../core/data/ControlDTO';
import { CampaignDTO } from '../data/CampaignDTO';
import { CampaignItemDTO } from '../data/CampaignItemDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CampaignItemProvider {
  private header = APIService.getHeader();
  itemret: any;

  constructor(public http: HttpClient, private translate: TranslateService) {}

  /**
   * GET campaigns
   */
  get(guidCampaign:string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaignitem?guidCampaign=${guidCampaign}`;
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          resolve(jsonData);

        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  getItemByGuid(guid: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaignitem?guid=${guid}`;
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignItemDTO;
          resolve(jsonData);

        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * POST campaign item
   */
  post(campaignItem: CampaignItemDTO, operation: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaignitem?operation=${operation}`;
      const requestData = JSON.stringify(campaignItem);
      this.http.post(url, requestData, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignItemDTO;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * DELETE campaign item by campaignId and itemId
   */
  delete(guidCampaign?: string, guid?: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `campaignitem?guidCampaign=${guidCampaign}&guid=${guid}`;
      this.http.delete(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignItemDTO;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * 
   * @param guid List history timeline
   * @returns 
   */
  getHistoryItemByGuid(guid?: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaignitemhistory?guidCampaignItem=${guid}`;
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          this.itemret = jsonData;
          resolve(this.itemret);

        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  
}
